/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmergencyAnalytics } from './EmergencyAnalytics';
import {
    EmergencyAnalyticsFromJSON,
    EmergencyAnalyticsFromJSONTyped,
    EmergencyAnalyticsToJSON,
    EmergencyAnalyticsToJSONTyped,
} from './EmergencyAnalytics';

/**
 * 
 * @export
 * @interface EmergencyAnalyticsResponse
 */
export interface EmergencyAnalyticsResponse {
    /**
     * 
     * @type {Array<EmergencyAnalytics>}
     * @memberof EmergencyAnalyticsResponse
     */
    one_month: Array<EmergencyAnalytics>;
    /**
     * 
     * @type {Array<EmergencyAnalytics>}
     * @memberof EmergencyAnalyticsResponse
     */
    six_months: Array<EmergencyAnalytics>;
}

/**
 * Check if a given object implements the EmergencyAnalyticsResponse interface.
 */
export function instanceOfEmergencyAnalyticsResponse(value: object): value is EmergencyAnalyticsResponse {
    if (!('one_month' in value) || value['one_month'] === undefined) return false;
    if (!('six_months' in value) || value['six_months'] === undefined) return false;
    return true;
}

export function EmergencyAnalyticsResponseFromJSON(json: any): EmergencyAnalyticsResponse {
    return EmergencyAnalyticsResponseFromJSONTyped(json, false);
}

export function EmergencyAnalyticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyAnalyticsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'one_month': ((json['oneMonth'] as Array<any>).map(EmergencyAnalyticsFromJSON)),
        'six_months': ((json['sixMonths'] as Array<any>).map(EmergencyAnalyticsFromJSON)),
    };
}

export function EmergencyAnalyticsResponseToJSON(json: any): EmergencyAnalyticsResponse {
    return EmergencyAnalyticsResponseToJSONTyped(json, false);
}

export function EmergencyAnalyticsResponseToJSONTyped(value?: EmergencyAnalyticsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oneMonth': ((value['one_month'] as Array<any>).map(EmergencyAnalyticsToJSON)),
        'sixMonths': ((value['six_months'] as Array<any>).map(EmergencyAnalyticsToJSON)),
    };
}

